import serverApi from "../utils/serverApi"

const activitiesService = {
  purchaseByProperyUuid: async (uuid) => {
    return await serverApi({ uri: `activities/purchase/${uuid}`, method: "GET" });
  },
}

export default activitiesService
